/**
 * Marks a browser tab that left for Meta's dialog from Settings → Company →
 * Meta access → Manage account users (Connect or Reconnect). A cancelled login
 * comes back to /authenticate-connector without a code, and the marker is how
 * that page knows to return to Meta access rather than report a connector
 * failure. Same rules as `agency-login-marker.ts`.
 */
const META_ACCOUNT_LOGIN_MARKER_KEY = "meta-access:account-user-login-started"
/** The API's nonce lives 10 minutes; an older marker is a login abandoned elsewhere. */
const META_ACCOUNT_LOGIN_MARKER_TTL_MS = 10 * 60 * 1000

function hasSessionStorage() {
  return typeof window !== "undefined" && typeof sessionStorage !== "undefined"
}

export function markMetaAccountLoginStarted(): void {
  if (!hasSessionStorage()) return
  sessionStorage.setItem(META_ACCOUNT_LOGIN_MARKER_KEY, Date.now().toString())
}

/** Whether this tab started an account-user login within the last 10 minutes; spends the marker. */
export function takeMetaAccountLoginMarker(): boolean {
  if (!hasSessionStorage()) return false
  const startedAt = Number(
    sessionStorage.getItem(META_ACCOUNT_LOGIN_MARKER_KEY),
  )
  sessionStorage.removeItem(META_ACCOUNT_LOGIN_MARKER_KEY)
  return (
    startedAt > 0 && Date.now() - startedAt < META_ACCOUNT_LOGIN_MARKER_TTL_MS
  )
}
